import React from 'react'

import { FormSectionCollapsible } from 'twyne-new.ui'

import SankeyD3 from './SankeyD3'
import { numberFormat, formatPath } from './formatters'

const CardTitle = ({ item }) => <div className='flex items-center min-w-0 max-md:flex-col max-md:gap-1 max-md:w-full max-md:text-center'>
  <span className='text-md truncate w-[70%] max-md:w-full'>{formatPath(item)}</span>
  <span className='mx-1 max-md:hidden'>-</span>
  <span className='text-sm twy-text-base max-md:w-full max-md:truncate'>{numberFormat(item.total)} total impressions</span>
</div>

const Header = ({ item }) => <div className='w-full flex justify-between items-center min-w-0'>
  <CardTitle item={item} />
</div>

const PathFinderBody = ({ item }) => <>
  <FormSectionCollapsible
    collapsible={false}
    defaultOpen
    border
    triggerClass='py-2 px-4 twy-subtle-neutral'
    contentClass='p-4 overflow-visible'
    titleClass='text-base pr-2'
    sectionClass='w-full overflow-visible min-w-0'
    title={<Header item={item} />}
  >
    <div className='w-full h-[670px]' id={`sankey-${item.value}`}>
      <SankeyD3
        data={item.sankey}
        containerId={`sankey-${item.value}`} />
    </div>
  </FormSectionCollapsible>
</>

export default PathFinderBody
